import { Logger } from '@alilc/lowcode-utils';
export { Logger };
export function getLogger(config) {
  return new Logger(config);
}